import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import BaseModal from 'flow/components/ui-components/BaseModal';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { getUsageGraphLink } from 'flow/utils';

interface Props {
    extensionKey?: ExtensionKey;
}

const MobileDataStatisticsModal = ({ extensionKey }: Props) => {
    const { i18next } = useAppContext();

    return (
        <BaseModal
            open={true}
            className="w-[600px]"
            header={i18next.t('settings.usage.data_usage')}
        >
            <img
                src={getUsageGraphLink(extensionKey, 'month')}
                alt={i18next.t('settings.usage.chart_month')}
                className="h-auto w-full"
            />
            <img
                src={getUsageGraphLink(extensionKey, 'year')}
                alt={i18next.t('settings.usage.chart_year')}
                className="h-auto w-full"
            />
        </BaseModal>
    );
};

export default MobileDataStatisticsModal;
